module.exports = __webpack_public_path__ + "img/22ne.29f11198.svg";